// extracted by mini-css-extract-plugin
module.exports = {"item":"UseCaseSection_item__9BpR4","title":"UseCaseSection_title__fVK8d"};